import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="border-t border-[#1E3A5F]/15 bg-[#1E3A5F] px-5 py-12 text-white lg:px-8">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="font-['Fraunces'] text-2xl">HF Cursos</p>
          


        </div>
        <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm" aria-label="Pie de página">
          <Link to="/cursos" className="hover:text-[#C41E3A]">Cursos</Link>
          <Link to="/instructores" className="hover:text-[#C41E3A]">Instructores</Link>
          <Link to="/contacto" className="hover:text-[#C41E3A]">Soporte</Link>
          <Link to="/acceso" className="hover:text-[#C41E3A]">Acceso</Link>
        </nav>
      </div>
      <p className="mx-auto mt-10 max-w-6xl text-xs text-white/50">
        © {new Date().getFullYear()} HFCursos. Todos los derechos reservados.
      </p>
    </footer>);

}

export default Footer;